import { format } from 'owa-strings/utilities/format';
import { getSDSCollectionItemId } from './getSDSCollectionItemId';
import { ITEM_ID_URL } from '../utils/constants';
import { makeSDSNetworkCall } from './makeSDSNetworkCall';

export async function getSDSCollectionItem(collectionName: string) {
    const itemId = await getSDSCollectionItemId(collectionName);
    if (itemId && typeof itemId === 'string') {
        return makeSDSNetworkCall(format(ITEM_ID_URL, collectionName, itemId), 'GET');
    }
    return null;
}
